import type { IconProps } from '../types/IconProps.ts';
export const Undo2: IconProps = {
    name: 'Undo2',
    children: [
        `<path d="M4 9h10.5a5.5 5.5 0 1 1 0 11H12" />`,
        `<path d="M9 4 4.14 8.86a.2.2 0 0 0 0 .28L9 14" />`,
    ]
};